import { render, staticRenderFns } from "./SendDialogRelation.vue?vue&type=template&id=b1c75462&scoped=true&"
import script from "./SendDialogRelation.vue?vue&type=script&lang=ts&"
export * from "./SendDialogRelation.vue?vue&type=script&lang=ts&"
import style0 from "styles/pages/visit/other-dialog.less?vue&type=style&index=0&id=b1c75462&scoped=true&lang=less&"
import style1 from "styles/pages/health-file/dialogSection__el.less?vue&type=style&index=1&lang=less&"
import style2 from "./SendDialogRelation.vue?vue&type=style&index=2&id=b1c75462&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c75462",
  null
  
)

export default component.exports